import axios from 'axios';
import { localToken, newTptMachineApiUrl } from '../../constants/apis/new_hud_apis';

const authConfig = () => ({
    headers: {
        "Content-Type": "application/json",
        Authorization: `Token ${localToken}`,
    },
});

// Returns the center's new TPT machines (paginated: { count, results: [...] }).
export const getNewTptMachines = async (branchName) => {
    const response = await axios.get(
        `${newTptMachineApiUrl}?branch_name=${encodeURIComponent(branchName)}`,
        authConfig(),
    );
    return response;
};

// Unlocks the machine so the patient can start the given dose.
export const startTptMachineDose = async (machineId, doseId) => {
    const response = await axios.post(
        `${newTptMachineApiUrl}${machineId}/start-dose/`,
        { dose_id: doseId },
        authConfig(),
    );
    return response;
};
